import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_glcode_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  chart_of_acc_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  gl_code_1: fromDatatype.VarcharDatatypeInterface;
  gl_code_2: fromDatatype.VarcharDatatypeInterface;
  gl_code_3: fromDatatype.VarcharDatatypeInterface;
  gl_code_4: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  gl_category_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_glcode_RowClass
  implements bl_fi_mst_glcode_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  chart_of_acc_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  gl_code_1: fromDatatype.VarcharDatatypeInterface;
  gl_code_2: fromDatatype.VarcharDatatypeInterface;
  gl_code_3: fromDatatype.VarcharDatatypeInterface;
  gl_code_4: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  gl_category_guid: fromDatatype.GuidDataFieldInterface;
}
